import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const visitorId = () => {
  let v = localStorage.getItem("ds_vid");
  if (!v) {
    v = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem("ds_vid", v);
  }
  return v;
};

export const PageViewTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/patron") || pathname.startsWith("/firma-panel")) return;
    axios.post(`${API}/track/pageview`, { path: pathname, vid: visitorId() }).catch(() => {});
  }, [pathname]);
  return null;
};
